<router-outlet>
</router-outlet>
<!-- As a heading -->
<header class="container-fluid fixed-top px-0">
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
        <h6 class="navbar-brand">Observatorio MOOC-CEDIA</h6>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav ml-auto">
                <!-- <li class="nav-item">
                    <a class="nav-link">Inicio</a>
                </li> -->
                <li class="nav-item active">
                    <a class="nav-link" (click)="moveSection(demografy)">Demografía</a>
                </li>
                <li class="nav-item active">
                    <a class="nav-link" (click)="moveSection(ranking)">Ranking</a>
                </li>
                <li class="nav-item active">
                    <a class="nav-link" (click)="moveSection(characteristics)">Características</a>
                </li>
                <li class="nav-item active">
                    <a class="nav-link" (click)="moveSection(platforms)">Plataformas</a>
                </li>
                <li class="nav-item active">
                    <a class="nav-link" (click)="openModal_aboutus(aboutus)">Acerca de</a>
                </li>
                <li class="nav-item active">
                    <a class="nav-link" (click)="moveSection(contact)">Contacto</a>
                </li>
            </ul>
        </div>
    </nav>
</header>
<section class="container pt-5 mt-5">
    <!-- <div class="row justify-content-center">
        <div class="col-3 col-md-2">
            <img src="/assets/images/logo.png" width="80%" alt="CEDIA">
        </div>
    </div> -->
    <div class="row justify-content-center pt-5">
        <div class="col-6 text-center">
            <h2 class="title"><b>Observatorio Digital MOOC</b></h2>
        </div>
    </div>
</section>

<!-- Seccion Selector de año -->
<section class="container pt-5">
    <div class="row justify-content-end">
        <div class="col-lg-6 text-right">
            <!-- Form data -->
            <form [formGroup]="dataForm">
                <div class="form-group row justify-content-end">
                    <label for="selectYear" class="col-7 col-form-label">Año de consulta</label>
                    <div class="col-4">
                        <select class="custom-select" id="selectYear" (change)="changeYear($event)" formControlName="year">
                            <option *ngFor="let year of years" [ngValue]="year">{{year}}</option>
                        </select>
                    </div>
                </div>
            </form>
            <!-- Form ends -->
        </div>
    </div>
</section>

<!-- Seccion Indicadores -->
<section class="container py-4">
    <div class="row pb-4">
        <div class="col-12">
            <h5>Indicadores</h5>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-12 col-md-4 my-3 my-md-0" *ngFor="let indicator of cards; let index = index">
            <div [tooltip]="indicator.definition" placement="bottom" class="card text-center indicator" [ngClass]="{'select' : indicator.select}" (click)="updateGraphs(indicator.type, index)">
                <div class="card-body">
                    <h5 class="card-title">{{indicator.type}}</h5>
                    <p class="card-text h2">{{indicator.value}}</p>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Seccion Demografía -->
<section #demografy class="container py-4">
    <div class="row pb-4">
        <div class="col-12">
            <h5>Demografía</h5>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <highcharts-chart [Highcharts]="Highcharts" constructorType="mapChart" [options]="chartOptionsMap" [(update)]=updateFlag6 style="width: 100%; height: 500px; display: block;">
            </highcharts-chart>
        </div>
    </div>
</section>
<!-- Seccion Ranking -->
<section #ranking class="container py-4">
    <div class="row pb-4">
        <div class="col-12">
            <h5>Ranking</h5>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div [chart]="coursesStackedBarChart"></div>
        </div>
    </div>
</section>
<!-- Seccion Características -->
<section #characteristics class="container py-4">
    <div class="row pb-4">
        <div class="col-12">
            <h5>Características</h5>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-12 col-md-6">
            <highcharts-chart [(update)]="updateFlag3" [Highcharts]="Highcharts" [options]="chartOptions3" style="width: 100%; height: 400px; display: block;"></highcharts-chart>
        </div>
        <div class="col-12 col-md-6">
            <highcharts-chart [(update)]="updateFlag4" [Highcharts]="Highcharts" [options]="chartOptions4" style="width: 100%; height: 400px; display: block;"></highcharts-chart>
        </div>
    </div>
    <!-- Duración promedio en horas de un MOOC por institución. -->
    <div class="row">
        <div class="col">
            <highcharts-chart [(update)]="updateFlag5" [Highcharts]="Highcharts" [options]="chartOptionsAvgDurationMooc" style="width: 100%; height: 500px; display: block;"></highcharts-chart>
        </div>
    </div>
</section>
<!-- Seccion Plataformas -->
<section #platforms class="container py-4">
    <div class="row pb-4">
        <div class="col-12">
            <h5>Plataformas</h5>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div [chart]="platformsStackedBarChart" style="width: 100%; height: 700px; display: block;"></div>
        </div>
    </div>
</section>
<!-- Seccion de contacto -->
<section #contact class="container py-4">
    <div class="row pb-4">
        <div class="col-12">
            <h5>Contacto</h5>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <p>Gonzalo Cordero 2-122 y José Fajardo. CP: 010203. Cuenca – Ecuador info@cedia.org.ec. Powered by CEDIA</p>
        </div>
    </div>
</section>
<!-- Pie de página -->

<!-- <footer class="container-fluid navbar-dark bg-dark text-white">
    <div class="row pt-3">
        <div class="col text-center">
            <p class="footer-text">
                Sitio desarrollado por Edu-Analytics (<a href="https://edu-analytics.ec/" target="_blank" class="text-white"><i>www.edu-analytics.ec</i></a>)
            </p>
        </div>
    </div>
    <div class="row justify-content-center pb-3">
        <div class="col-6 col-sm-2">
            <img src="/assets/images/eduAnalytics.png" width="100%" alt="edu-analytics">
        </div>
    </div>
</footer> -->


<ng-template #aboutus>
    <div class="modal-header">
        <h6 class="modal-title tittle-5 ml-3 mt-2">OBSERVATORIO MOOC – CEDIA</h6>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefAboutUs.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body text-justify">
        <div class="row px-3">
            <div class="col-12">
                <p class="">El objetivo de este sitio es difundir el trabajo realizado en el estudio “Estado del arte de la adopción de MOOCs en Ecuador y reporte de oferta de cursos.”</p>

                <p>El informe es fruto del trabajo conjunto realizado por el equipo de CEDIA y la Consultora Edu-Analytics, en el que se realizó un levantamiento de los datos de cursos MOOCs existentes en Ecuador. Puedes acceder a la información recopilada
                    de los datos de MOOCS para Ecuador en 2020.</p>


                <p>Finalmente, al explorar este sitio encontrarás la demografía de los cursos, un ranking de las mayores instituciones prodctoras de MOOCs, las características de los cursos, las diferentes tipos de y una visión general del estado actual.</p>
            </div>
        </div>
    </div>
</ng-template>